import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { RiPencilFill } from "react-icons/ri";
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
import LeadFieldsAddAndEditModal from './components/LeadFieldAddAndEditModal';
import { useLeadFieldsData } from './hooks/useLead';
import { FaEdit } from 'react-icons/fa';

const LeadFieldsColumns = (handleEditLeadField: (row: any) => void) => [
    {
        name: "Field Name",
        selector: (row: { FieldName: string }) => row.FieldName || '-',
        sortable: true,
        width: '40%',
         wrap:true
    },
    {
        name: "Field Type",
        selector: (row: { FieldType: string }) => row.FieldType || '-',
        sortable: true,
        width: '40%',
         wrap:true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center">
                <button
                    onClick={() => handleEditLeadField(row)}
                    className="btn btn-primary"
                    style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                >
                    <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                </button>
            </div>
        ),
    },
]


// CompanyId
// : 
// 9
// CreatedAt
// : 
// "2025-05-26 15:26:40.000000"
// IsActive
// : 
// null
// LeadName
// : 
// "TestingLead12"
// LeadTypeId
// : 
// 2
// OutletTypeId
// : 
// 196
// SubscriberTypes
// : 
// "2"


const LeadFields = () => {

    const location = useLocation();
    const { leadRowData } = location?.state || {};
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [rowData, setRowData] = useState(false);
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const [paginationStates, setPaginationStates] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
    });
    const { data } = useLeadFieldsData({
        LeadTypeId: leadRowData?.LeadTypeId,
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
        }
    })
    const handleEditLeadField = (row:any) => {
        setRowData(row)
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(true);
    }
    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };

    return (
        <div
            className="p-4"
        >
            <PageHeader
                title="Lead"
                buttons={[
                    {
                        label: "+ Add Lead Field",
                        onClick: toggleModal,
                        color: "#2e8dd3",
                    },

                ]}
            />
            <BasicDataTable
                paginationTotalRows={data?.data?.recordsTotal || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => { handleSearch(val) }}
                Title="Lead Fields"
                columns={LeadFieldsColumns(handleEditLeadField)}
                data={data?.data?.data || []}
            />
            <LeadFieldsAddAndEditModal rowData={rowData} LeadTypeId={leadRowData?.LeadTypeId} setCheckAddEditStatus={setCheckAddEditStatus}  checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add Lead Field' : 'Edit Lead Field'} />
        </div>
    )
}

export default LeadFields
